module.exports = __webpack_public_path__ + "img/4.c4c26cb0.png";